import { useState, useEffect } from 'react';
import {ApiUrl} from "../../ApiUrl"


const useFetchLanguages = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLanguages = async () => {
      const url = `${ApiUrl.apiurl}LANGUAGE/GetAllLanguageList/`;  

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        console.log(result);  
       
        setData(result.data || []); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLanguages();
  }, []);

  return { data, loading, error };
};

export default useFetchLanguages;
